import { DataAccessService } from '../../core/api';

/**
 * Get the repository with the given URL and manager (if it exists)
 *
 * @param {string} repoUrl - URL of the repository to find
 * @param {string} managerAlias - Owning manager of the repository
 * @returns {Object|undefined} - The repository object if found, undefined otherwise
 */
export async function getRepo(repoUrl, managerAlias) {
  try {
    const response = await getRepos();

    if (!response || !response.repos) {
      return undefined;
    }

    // Find the specific repository
    return response.repos.find((repo) => repo.url === repoUrl && repo.managerAlias === managerAlias);
  } catch (error) {
    console.warn('Error fetching repository:', error);
    throw error; // Rethrow to propagate the error
  }
}

/**
 * Fetches all repositories from the server.
 *
 * This function retrieves all repositories from the /repos endpoint.
 * The backend automatically handles authorization and filtering.
 *
 * @returns {Object} - An object containing the repositories
 */
export async function getRepos() {
  const client = new DataAccessService({
    baseURL: `${window.location.protocol}//${window.location.host}`,
  });

  try {
    // Fetch all repos at once
    const response = await client.get('/repos');

    if (!response || !response.repos) {
      return {
        repos: [],
      };
    }

    // Return the repos
    return response;
  } catch (err) {
    console.warn(err);
    throw err;
  }
}
